<template>
  <layout-content>
    <filter-component />
    <badge-component />
    <table-component />

    <i-button slot="top-buttons" type="primary" size="large" @click="add">
      {{ $t('phone-number.number.modal.add_custom.title') }}
    </i-button>
  </layout-content>
</template>

<script>
  import FilterComponent from '@phone-number/components/numbers-list-table-filter';
  import BadgeComponent from '@phone-number/components/numbers-list-badge-counter';
  import TableComponent from '@phone-number/components/numbers-list-table';
  import { mapActions } from 'vuex';
  import { NumberModalService } from '@phone-number/modals/NumberModalService';

  export default {
    components: {
      FilterComponent,
      BadgeComponent,
      TableComponent
    },

    created() {
      this.getList();
    },

    methods: {
      ...mapActions('phone-number/numbers/table', ['getAsyncData']),
      ...mapActions('phone-number/user_countries/list', ['getList']),

      add: function () {
        NumberModalService.add_custom().on('success', () => this.getAsyncData());
      }
    }
  };
</script>
